import { navigate } from 'gatsby'
import clsx from 'clsx'
import { ColumnsType, Link, Table, TableProps, Tag } from 'components/common'
import { BookingDate, OrderApproval, OrderStatus } from 'lib/graphql/storeadmin'
import { date as formatDate } from 'lib/str-formatter'
import { routes } from 'config'

export interface CustomerBooking {
  key: string
  orderNumber: number
  bookingDates: BookingDate[]
  contents: string[]
  originalTotalPrice: number
  reservationStatus: BookingDate[]
  status: OrderStatus
  approval: OrderApproval
}

type InternalProps = TableProps<CustomerBooking>
type Actions = Pick<
  InternalProps,
  'pagination' | 'rowSelection' | 'columns' | 'onChange' | 'onRow'
>
// TODO: Phase 1 ではコメントアウト
// type RowSelection = InternalProps['rowSelection']
export interface OrderByCustomerProps
  extends Omit<InternalProps, 'onChange' | 'onRow'> {
  dataSource: Array<CustomerBooking>
}

const columns: ColumnsType<CustomerBooking> = [
  {
    key: 'orderNumber',
    title: '予約 No.',
    dataIndex: 'orderNumber',
    render: (text: string) => <Link>#{text}</Link>,
  },
  {
    key: 'bookingDates',
    title: '利用予定日',
    dataIndex: 'bookingDates',
    render: (dates: BookingDate[]) => {
      if (dates?.length === 1) {
        return <div>{formatDate(dates[0].date)}</div>
      } else if (dates?.length > 1) {
        return (
          <div>
            {formatDate(dates[0].date)} -{' '}
            {formatDate(dates[dates.length - 1].date)}
          </div>
        )
      } else {
        return <div />
      }
    },
  },
  {
    key: 'contents',
    title: '内容',
    dataIndex: 'contents',
    render: (values) => values.map((value: string) => <div>{value}</div>),
  },
  {
    key: 'originalTotalPrice',
    title: '金額',
    dataIndex: 'originalTotalPrice',
    render: (text: string) => <div>￥{text}</div>,
  },
  {
    key: 'checkinStatus',
    title: 'チェックイン',
    dataIndex: 'checkinStatus',
    render: (value) => {
      const lastValue = value[value.length - 1]
      if (lastValue.checkedInAt !== null && lastValue.checkedOutAt !== null) {
        return <Tag color={'processing'}>チェックアウト済</Tag>
      } else if (lastValue.checkedInAt === null) {
        return <Tag color={'warning'}>チェックイン前</Tag>
      } else {
        return <Tag color={'success'}>チェックイン中</Tag>
      }
    },
  },
  // TODO: after finished api implementation redo it
  // {
  //   key: 'paymentStatus',
  //   title: '支払い',
  //   dataIndex: 'paymentStatus',
  //   render: (value) => {
  //     switch (value.status) {
  //       case 'WAIT':
  //         return <Tag color={'processing'}>支払い待ち</Tag>
  //       case 'COMPLETE':
  //         return <Tag color={'success'}>支払い完了</Tag>
  //       case 'FAILURE':
  //         return <Tag color={'success'}>支払不備</Tag>
  //       default:
  //         return <Tag color={'warning'}>支払いはありません</Tag>
  //     }
  //   },
  // },
  {
    key: 'approval',
    title: '承認',
    dataIndex: 'approval',
    render: (value) => {
      switch (value) {
        case OrderApproval.Approved:
          return <Tag color={'success'}>承認済み</Tag>
        case OrderApproval.Pending:
          return <Tag color={'warning'}>承認待ち</Tag>
        case OrderApproval.Disapproved:
          return <Tag color={'error'}>非承認</Tag>
        default:
          return null
      }
    },
  },
]

export const CustomerBookingsTable = ({
  dataSource,
  ...restProps
}: OrderByCustomerProps): JSX.Element => {
  /* TODO: Phase 1 ではコメントアウト
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>()

  const rowSelection: RowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
  }
  */

  const onRow: Actions['onRow'] = (record, action) => {
    return {
      onClick: async (event) => {
        await navigate(`${routes.bookings}/${record.key}`)
      },
    }
  }

  return (
    <>
      <Table<CustomerBooking>
        pagination={false}
        // rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource}
        scroll={{ x: 1300 }}
        rowClassName={clsx('cursor-pointer')}
        onRow={onRow}
        {...restProps}
      />
    </>
  )
}
